import {
  LOAD_SUCCESS_RAPPROCHEMENTS_BANCAIRES,
  LOAD_FAIL_RAPPROCHEMENTS_BANCAIRES,
  SAVE_SUCCESS_RAPPROCHEMENTS_BANCAIRES,
  SAVE_FAIL_RAPPROCHEMENTS_BANCAIRES,
  UPDATE_SUCCESS_RAPPROCHEMENTS_BANCAIRES,
  UPDATE_FAIL_RAPPROCHEMENTS_BANCAIRES,
  DELETE_SUCCESS_RAPPROCHEMENTS_BANCAIRES,
  DELETE_FAIL_RAPPROCHEMENTS_BANCAIRES,
} from "../actions/rapprochementBancaireAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_RAPPROCHEMENTS_BANCAIRES:
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_RAPPROCHEMENTS_BANCAIRES:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_RAPPROCHEMENTS_BANCAIRES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_RAPPROCHEMENTS_BANCAIRES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_RAPPROCHEMENTS_BANCAIRES:
      const updatedListe = [];

      state.data.forEach((item) => {
        if (item.rapprochement_bancaire_id === action.payload.rapprochement_bancaire_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_RAPPROCHEMENTS_BANCAIRES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_RAPPROCHEMENTS_BANCAIRES:
      const filtered = state.data.filter((item) => {
        return item.rapprochement_bancaire_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_RAPPROCHEMENTS_BANCAIRES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
